import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, LayersIcon, ClipboardCheckIcon, HeadphonesIcon } from 'lucide-react';
const deliverables = [{
  icon: FileTextIcon,
  title: "The Complete 11PM 'Reset' Protocol",
  description: '(PDF + Audio Bundle) The core manual that breaks down the exact science and steps to reclaim your night.'
}, {
  icon: LayersIcon,
  title: 'The Dopamine-Buffer Step-Down Framework',
  description: 'A gentle transition system that moves you from high-stimulation screens to deep relaxation without forced bans.'
}, {
  icon: ClipboardCheckIcon,
  title: 'The Bedside Trigger Audit & Morning Resentment Map',
  description: 'Identify the hidden environmental cues keeping you awake and map out a morning you actually want to wake up for.'
}, {
  icon: HeadphonesIcon,
  title: 'The 7-Minute "Midnight FM" Audio Guide',
  description: 'Press play when you get into bed. This guided audio walks your nervous system down into deep sleep mode.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800 border-y border-navy-700" data-id="element-146">
      <div className="max-w-6xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-148">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-149">
            What You Get Inside
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full" data-id="element-150" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-151">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-navy-700 rounded-2xl p-8 border border-navy-600 hover:border-amber-500/50 transition-colors group" data-id="element-152">
                <div className="flex items-start space-x-6" data-id="element-153">
                  <div className="flex-shrink-0 w-14 h-14 bg-navy-900 rounded-xl flex items-center justify-center border border-navy-600 group-hover:border-amber-500/50 transition-colors" data-id="element-154">
                    <Icon className="w-7 h-7 text-amber-500" data-id="element-155" />
                  </div>
                  <div data-id="element-156">
                    <h3 className="font-heading text-xl font-semibold text-white mb-2 leading-tight" data-id="element-157">
                      {item.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed" data-id="element-158">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}